module.exports = __webpack_public_path__ + "img/absorbente9.792c2a1b.jpg";